import { render, staticRenderFns } from "./NewDuplicateCard.vue?vue&type=template&id=34de322a&scoped=true"
import script from "./NewDuplicateCard.vue?vue&type=script&lang=ts"
export * from "./NewDuplicateCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34de322a",
  null
  
)

export default component.exports